import { render, staticRenderFns } from "./SubServices.vue?vue&type=template&id=ca3951c4&scoped=true&"
import script from "./SubServices.vue?vue&type=script&lang=js&"
export * from "./SubServices.vue?vue&type=script&lang=js&"
import style0 from "./SubServices.vue?vue&type=style&index=0&id=ca3951c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3951c4",
  null
  
)

export default component.exports